import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';

export const NewsDetailPageSkeleton: React.FC = () => {
  return (
    <>
      <Box
        sx={{ bgcolor: 'secondary.light', py: 5, borderBottom: 1, borderColor: 'divider' }}
        className="container-fluid"
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Grid spacing={1.5} container justifyContent="center" sx={{ mb: 2 }}>
            {_.times(2).map((_item, index) => (
              <Grid key={index} item>
                <Skeleton variant="rectangular" width="10rem" sx={{ borderRadius: '30rem' }} />
              </Grid>
            ))}
          </Grid>
          <Skeleton variant="rectangular" height="2.5rem" sx={{ mb: 1 }} width="min(35rem, 100%)" />
          <Grid container spacing={1.5} justifyContent="center">
            <Grid item>
              <Skeleton variant="rectangular" width="7.5rem" sx={{ borderRadius: '30rem' }} />
            </Grid>
            <Grid item>
              <Skeleton variant="text" width="7.5rem" />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="container-fluid" sx={{ py: 5 }}>
        <Skeleton variant="rectangular" width="100%" height="30rem" />
      </Box>
    </>
  );
};
